
import { Component, OnDestroy, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription, take } from 'rxjs';

@Component({
	templateUrl: 'logout.component.html'
})
export class LogoutComponent implements OnInit, OnDestroy {
	logoutSubscription: Subscription | undefined;

	constructor(private _oidcSecurityService: OidcSecurityService) {
	}

	ngOnInit(): void {
		this.logoffAndRevokeTokens();
	}

	logoffAndRevokeTokens() {
		this.logoutSubscription = this._oidcSecurityService.logoffAndRevokeTokens()
			.subscribe((result) => {
				sessionStorage.clear();
			});	

		let path = localStorage.getItem("doLogout");
		if (path) {
			localStorage.removeItem("doLogout");

		}
		else {
			localStorage.setItem("doLogout", "true");
		}
	}

	ngOnDestroy(): void {
		if (this.logoutSubscription) {
			this.logoutSubscription.unsubscribe();
		}
	}
}
